module.exports = __webpack_public_path__ + "static/img/WeChat_official_account@2x.1d7db4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/WeChat_official_account@2x.png
// module id = OlWv
// module chunks = 8